export class LoadAdminPerformersAction {
  static readonly type = '[AdminPerformers] Load perofrmers';
};